"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    DATA_CHANNEL_ANSWER_RECEIVED: 'DATA_CHANNEL_ANSWER_RECEIVED',
    DATA_CHANNEL_CLOSED: 'DATA_CHANNEL_CLOSED',
    DATA_CHANNEL_CLOSING: 'DATA_CHANNEL_CLOSING',
    DATA_CHANNEL_CREATE_OFFER: 'DATA_CHANNEL_CREATE_OFFER',
    DATA_CHANNEL_ICECANDIDATE: 'DATA_CHANNEL_ICECANDIDATE',
    DATA_CHANNEL_OFFER_RECEIVED: 'DATA_CHANNEL_OFFER_RECEIVED',
    DATA_CHANNEL_OPENED: 'DATA_CHANNEL_OPENED',
    DATA_CHANNEL_SEND_MESSAGE: 'DATA_CHANNEL_SEND_MESSAGE',
    DATA_CHANNEL_STREAM_ENDED: 'DATA_CHANNEL_STREAM_ENDED',
    DATA_CHANNEL_RECONNECT: 'DATA_CHANNEL_RECONNECT',
    GRAPHITE_EVENT_RECEIVED: 'GRAPHITE_EVENT_RECEIVED',
    REMOTE_ACTION_RECEIVED: 'REMOTE_ACTION_RECEIVED',
    REMOTE_STATE_UPDATED: 'REMOTE_STATE_UPDATED',
    REMOTING_ERROR: 'REMOTING_ERROR',
    SEND_STATE_REQUESTED: 'SEND_STATE_REQUESTED',
    WIRELESS_PRESENTATION_ANSWER_RECEIVED: 'WIRELESS_PRESENTATION_ANSWER_RECEIVED',
    WIRELESS_PRESENTATION_CREATE_OFFER: 'WIRELESS_PRESENTATION_CREATE_OFFER',
    WIRELESS_PRESENTATION_EXCHANGE_PRESENTER: 'WIRELESS_PRESENTATION_EXCHANGE_PRESENTER',
    WIRELESS_PRESENTATION_ICE_STATE_CHANGE: 'WIRELESS_PRESENTATION_ICE_STATE_CHANGE',
    WIRELESS_PRESENTATION_ICECANDIDATE: 'WIRELESS_PRESENTATION_ICECANDIDATE',
    WIRELESS_PRESENTATION_OFFER_RECEIVED: 'WIRELESS_PRESENTATION_OFFER_RECEIVED',
    WIRELESS_PRESENTATION_ON_STREAM: 'WIRELESS_PRESENTATION_ON_STREAM',
    WIRELESS_PRESENTATION_SEND_END: 'WIRELESS_PRESENTATION_SEND_END',
    WIRELESS_PRESENTATION_SEND_START: 'WIRELESS_PRESENTATION_SEND_START',
    WIRELESS_PRESENTATION_STOP: 'WIRELESS_PRESENTATION_STOP',
    WIRELESS_PRESENTATION_STREAM_ENDED: 'WIRELESS_PRESENTATION_STREAM_ENDED'
};
exports.callLayouts = {
    split: 'split',
    participants: 'participants',
    presentation: 'presentation'
};
exports.topics = {
    graphiteTopic: 'ls.deviceMessaging'
};
exports.service = {
    name: 'lifesize.deviceMessaging',
    actions: {
        sendAction: 'sendAction',
        sendState: 'sendState',
        requestState: 'requestState'
    },
    proxyActions: {
        add: 'ADD',
        answer: 'ANSWER',
        call: 'CALL',
        cancelCall: 'CANCEL_CALL',
        clearCall: 'CLEAR_CALL',
        directorySearch: 'DIRECTORY_SEARCH',
        doNotDisturb: 'DO_NOT_DISTURB',
        end: 'END',
        endAndAnswer: 'END_AND_ANSWER',
        ignore: 'IGNORE',
        sendMeetingPin: 'SEND_MEETING_PIN',
        sendDtmf: 'SEND_DTMF',
        toggleAudioMute: 'TOGGLE_AUDIO_MUTE',
        toggleVideoMute: 'TOGGLE_VIDEO_MUTE',
        addFavorite: 'ADD_FAVORITE',
        removeFavorite: 'REMOVE_FAVORITE',
        removeRecent: 'REMOVE_RECENT',
        raiseHand: 'RAISE_HAND',
        lowerOwnHand: 'LOWER_OWN_HAND'
    },
    directoryActions: {
        fetchNext: 'FETCH_NEXT',
        fetchActiveMeetings: 'FETCH_ACTIVE_MEETINGS'
    },
    moderatorActions: {
        muteAll: 'moderatorMuteAll',
        muteParticipant: 'moderatorMuteParticipant',
        removeParticipant: 'moderatorRemoveParticipant',
        endAll: 'moderatorEndAll',
        stopPresentation: 'moderatorStopPresentation',
        lockMeeting: 'lockMeeting',
        unlockMeeting: 'unlockMeeting',
        lowerAllHands: 'lowerAllHands',
        lowerParticipantHand: 'lowerParticipantHand',
        selectParticipant: 'selectParticipant'
    },
    feccActions: {
        panLeft: 'feccPanLeft',
        panRight: 'feccPanRight',
        zoomIn: 'feccZoomIn',
        zoomOut: 'feccZoomOut',
        tiltUp: 'feccTiltUp',
        tiltDown: 'feccTiltDown',
        panLeftStop: 'feccPanLeftStop',
        panRightStop: 'feccPanRightStop',
        zoomInStop: 'feccZoomInStop',
        zoomOutStop: 'feccZoomOutStop',
        tiltUpStop: 'feccTiltUpStop',
        tiltDownStop: 'feccTiltDownStop',
        moveToPreset: 'feccMoveToPreset'
    },
    wirelessActions: {
        answer: 'wirelessPresentationAnswer',
        end: 'wirelessPresentationEnd',
        ice: 'wirelessPresentationIceCandidate',
        offer: 'wirelessPresentationOffer',
        /** Action sent from the remote to stop the wireless presentation at the display */
        stop: 'wirelessPresentationStop'
    },
    dataChannel: {
        ice: 'dataChannelIceCandidate',
        offer: 'dataChannelOffer',
        answer: 'dataChannelAnswer',
        end: 'dataChannelEnd'
    },
    events: {
        topic: 'ls.deviceMessaging',
        types: {
            actionReceived: 'sendAction',
            remoteStateUpdated: 'sendState',
            stateRequested: 'requestState',
            displayPaired: 'displayPaired',
            displayUnpaired: 'displayUnpaired',
            sdp: 'sdp',
            iceCandidate: 'iceCandidate'
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/constants/remoting.js
// module id = 40
// module chunks = 0